import { ELEMENT_TYPE } from '@constants'

export const getEditElementValueByElementType = (
  elementType: ELEMENT_TYPE | null | undefined,
  elementId: string | number | null | undefined,
  elementTitle: string | null | undefined
) => {
  switch (elementType) {
    case ELEMENT_TYPE.COMMAND: {
      return elementTitle ? { id: elementTitle, label: elementTitle } : null
    }
    default:
      return elementId && elementTitle ? { id: elementId, label: elementTitle } : null
  }
}
